import React from 'react';
import { styled } from '@mui/material/styles';
import { removeIdentityMasking } from '../../../../utils';

const MessageInfoContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '1.425em 0 0.083em',
  fontSize: '12px',
  color: '#606B85',
});

interface MessageInfoProps {
  author: string;
  dateCreated: string;
  isLocalParticipant: boolean;
}

export default function MessageInfo({ author, dateCreated, isLocalParticipant }: MessageInfoProps) {
  return (
    <MessageInfoContainer>
      <div>{isLocalParticipant ? `${removeIdentityMasking(author)} (You)` : removeIdentityMasking(author)}</div>
      <div>{dateCreated}</div>
    </MessageInfoContainer>
  );
}
